import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { from, switchMap, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';
import { GetDashboardSellerKpisParams } from 'src/app/models/core/kpis.model';
import { RecentTicketsResponse } from 'src/app/models/core/recent-ticket.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardSellerApiService {

  private baseUrl = `${environment.api_server}/api/sellers`;

  constructor(private _http: HttpClient, private _api: ApiService) { }

  getDashboardSellerKpis(params: GetDashboardSellerKpisParams): Observable<any> {
    const { role, section, extras } = params;
    const url = `${this.baseUrl}/dashboard/kpis`;

    let httpParams = new HttpParams().set('role', role);
    if (section) {
      httpParams = httpParams.set('section', section);
    }

    if (extras) {
      Object.entries(extras).forEach(([key, value]) => {
        httpParams = httpParams.set(key, value);
      });
    }

    return from(this._api.getAuthHeaders()).pipe(
      switchMap((headers) =>
        this._http.get(url, { headers, params: httpParams })
      )
    );
  }

  getDashboardSalesTypeGraphByRange(
    role: string,
    range: string
  ): Observable<any> {
    const url = `${this.baseUrl}/dashboard/sales-type-table`;
    const params = new HttpParams()
      .set('role', role)
      .set('range', range);

    return from(this._api.getAuthHeaders()).pipe(
      switchMap((headers) => this._http.get(url, { headers, params }))
    );
  }

  getRecentTickets(): Observable<RecentTicketsResponse> {
    const url = `${this.baseUrl}/dashboard/recent-tickets`;

    return from(this._api.getAuthHeaders()).pipe(
      switchMap((headers) =>
        this._http.get<RecentTicketsResponse>(url, { headers })
      )
    );
  }

}
